/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DevAutoLoginResponse,
  ExchangeTokenRequest,
  ExchangeTokenResponse,
  LoginRequest,
  LoginResponse,
  MagicOttResponse,
  MeResponse
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const devAutoLogin = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DevAutoLoginResponse>(
      {url: `/api/auth/dev-login`, method: 'POST', signal
    },
      );
    }
  


export const getDevAutoLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devAutoLogin>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof devAutoLogin>>, TError,void, TContext> => {

const mutationKey = ['devAutoLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devAutoLogin>>, void> = () => {
          

          return  devAutoLogin()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevAutoLoginMutationResult = NonNullable<Awaited<ReturnType<typeof devAutoLogin>>>
    
    export type DevAutoLoginMutationError = ErrorType<void>

    export const useDevAutoLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devAutoLogin>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devAutoLogin>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDevAutoLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const exchangeToken = (
    exchangeTokenRequest: ExchangeTokenRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ExchangeTokenResponse>(
      {url: `/api/auth/exchange-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangeTokenRequest, signal
    },
      );
    }
  


export const getExchangeTokenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenRequest}, TContext> => {

const mutationKey = ['exchangeToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeToken>>, {data: ExchangeTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  exchangeToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExchangeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeToken>>>
    export type ExchangeTokenMutationBody = ExchangeTokenRequest
    export type ExchangeTokenMutationError = ErrorType<void>

    export const useExchangeToken = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,{data: ExchangeTokenRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exchangeToken>>,
        TError,
        {data: ExchangeTokenRequest},
        TContext
      > => {

      const mutationOptions = getExchangeTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const login = (
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponse>(
      {url: `/api/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }
  


export const getLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  login(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginRequest
    export type LoginMutationError = ErrorType<void>

    export const useLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const loginWeb = (
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<LoginResponse>(
      {url: `/api/auth/login-web`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }
  


export const getLoginWebMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWeb>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof loginWeb>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['loginWeb'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginWeb>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  loginWeb(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginWebMutationResult = NonNullable<Awaited<ReturnType<typeof loginWeb>>>
    export type LoginWebMutationBody = LoginRequest
    export type LoginWebMutationError = ErrorType<void>

    export const useLoginWeb = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginWeb>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginWeb>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getLoginWebMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const logout = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      );
    }
  


export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
          

          return  logout()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>
    
    export type LogoutMutationError = ErrorType<unknown>

    export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const magicOtt = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MagicOttResponse>(
      {url: `/api/auth/magic-ott`, method: 'POST', signal
    },
      );
    }
  


export const getMagicOttMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof magicOtt>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof magicOtt>>, TError,void, TContext> => {

const mutationKey = ['magicOtt'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof magicOtt>>, void> = () => {
          

          return  magicOtt()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MagicOttMutationResult = NonNullable<Awaited<ReturnType<typeof magicOtt>>>
    
    export type MagicOttMutationError = ErrorType<unknown>

    export const useMagicOtt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof magicOtt>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof magicOtt>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getMagicOttMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MeResponse>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      );
    }
  



export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<void>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const refreshPermissionCache = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/permission-cache/refresh`, method: 'POST', signal
    },
      );
    }
  


export const getRefreshPermissionCacheMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPermissionCache>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshPermissionCache>>, TError,void, TContext> => {

const mutationKey = ['refreshPermissionCache'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPermissionCache>>, void> = () => {
          

          return  refreshPermissionCache()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshPermissionCacheMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPermissionCache>>>
    
    export type RefreshPermissionCacheMutationError = ErrorType<void>

    export const useRefreshPermissionCache = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPermissionCache>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshPermissionCache>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRefreshPermissionCacheMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const refreshPermissions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/auth/refresh-permissions`, method: 'POST', signal
    },
      );
    }
  


export const getRefreshPermissionsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPermissions>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshPermissions>>, TError,void, TContext> => {

const mutationKey = ['refreshPermissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshPermissions>>, void> = () => {
          

          return  refreshPermissions()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RefreshPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof refreshPermissions>>>
    
    export type RefreshPermissionsMutationError = ErrorType<void>

    export const useRefreshPermissions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshPermissions>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshPermissions>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getRefreshPermissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    